import React, { useState } from 'react';
import axios from 'axios';
import { FaPaperPlane, FaEnvelopeOpenText } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Subscribe.css';

const NewsletterSubscribe = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error('Email is required.');
      return;
    }

    if (!isValidEmail(email)) {
      toast.error('Please enter a valid email address.');
      return;
    }

    setIsSubmitting(true);

    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Client-Domain': process.env.REACT_APP_CLIENT_DOMAIN,
        },
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}website/subscribe/store`,
        { email },
        options
      );

      const messageText = response?.data?.message?.toLowerCase();

      if (messageText?.includes('already')) {
        toast.info('You are already subscribed.');
      } else {
        toast.success('Subscribed successfully!');
      }

      setEmail('');
    } catch (err) {
      console.error('Subscription error:', err);
      toast.error('Subscription failed. Try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="newsletter-wrapper">
      <div className="newsletter-container">
        <div className="newsletter-left">
          <h2>Subscribe</h2>
          <p>to our newsletter</p>
          <form onSubmit={handleSubscribe} className="newsletter-form">
            <input
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="send-btn" disabled={isSubmitting}>
              {isSubmitting ? <span className="spinner" /> : <FaPaperPlane />}
            </button>
          </form>
        </div>

        <div className="newsletter-right">
          <FaEnvelopeOpenText className="newsletter-icon" />
        </div>
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        pauseOnHover
        closeOnClick
        theme="light"
      />
    </div>
  );
};

export default NewsletterSubscribe;
